interface ICheckIsAdminRoleParams {
  role: string | null | undefined;
}

export function checkIsAdminRole({ role }: ICheckIsAdminRoleParams): boolean {
  if (!role) {
    return false;
  }

  return role === 'admin';
}
